var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaskPhonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.62 10.79C8.06 13.62 10.38 15.93 13.21 17.38L15.41 15.18C15.68 14.91 16.08 14.82 16.43 14.94C17.55 15.31 18.76 15.51 20 15.51C20.55 15.51 21 15.96 21 16.51V20C21 20.55 20.55 21 20 21C10.61 21 3 13.39 3 4.00001C3 3.45001 3.45 3.00001 4 3.00001H7.5C8.05 3.00001 8.5 3.45001 8.5 4.00001C8.5 5.25001 8.7 6.45001 9.07 7.57001C9.18 7.92001 9.1 8.31001 8.82 8.59001L6.62 10.79ZM20.16 3.69001L19.45 2.99001L13 9.29001V5.00001H12V11H18V10H13.85L20.16 3.69001Z",
    fill: "#66BB6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskPhonIcon);
export default __webpack_public_path__ + "static/media/TaskPhonIcon.34af5ca854c16e29c8737df81eaf7f35.svg";
export { ForwardRef as ReactComponent };